<template>
  <div class="color-sample n2-west">
    <section>
      <p class="small-text">
        平成三年 十二月三十 一日 没
      </p>
    </section>
    <section class="flex center grow adjust-top">
      <div class="box">
        <p class="small-text">
          俗名
        </p>
      </div>
      <div class="box flex center grow column adjust-padding">
        <p class="box default-text small-letter-spacing">
          源頼朝
        </p>
        <p class="box default-text small-letter-spacing">
          源頼朝
        </p>
      </div>
      <div class="box flex center grow column adjust-padding">
        <p class="box default-text small-letter-spacing">
          享年
        </p>
        <p class="box default-text small-letter-spacing">
          享年
        </p>
      </div>
      <div class="box flex center grow column adjust-padding">
        <p class="box default-text small-letter-spacing">
          八十八歳
        </p>
        <p class="box default-text small-letter-spacing">
          八十八歳
        </p>
      </div>
      <div class="box grow" />
    </section>
    <section>
      <p class="small-text">
        平成三年 十二月三十 一日 没
      </p>
    </section>
  </div>
</template>

<script>
export default {
  components: {
  },
  props: {
  },
  mounted () {},
  data () {
    return {
    };
  },
  computed: {
  },
  watch: {},
  destroyed () {},
  methods: {},
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/variables.scss";
@import "~@/assets/styles/tablet-back.scss";
</style>
